import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "mb-2" };
const _hoisted_2 = { class: "mb-2" };
const _hoisted_3 = { "data-test": "regEndDate" };
const _hoisted_4 = { class: "mb-4" };
import { ref, toRef, computed } from "vue";
import AppDialogContent from "@elements/AppDialogContent.vue";
import AppDatePicker from "@elements/AppDatePicker.vue";
import { injectSnackbarError } from "@composables/injections";
import { apolloClient } from "@/plugins/apollo";
import gql from "fraql";
const __default__ = {
    name: "CompetitionRegistrationOverwrite",
    fragments: {
        competitionFields: gql `
      fragment _ on Competition {
        id
        registrationEndDate
        feiEvent {
          id
          nominatedEntriesDate
          definiteEntriesDate
        }
      }
    `
    }
};
export default /*@__PURE__*/ _defineComponent({
    ...__default__,
    props: {
        event: {
            type: Object,
            required: true
        }
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const { snackbarServerError } = injectSnackbarError();
        const event = toRef(props, "event");
        const competition = ref();
        const dialog = ref(false);
        const registrationEndDateOverride = ref(null);
        const mutationLoading = ref(false);
        const nominatedEntriesDate = computed(() => competition.value?.feiEvent?.nominatedEntriesDate);
        const definiteEntriesDate = computed(() => competition.value?.feiEvent?.definiteEntriesDate);
        const registrationEndDate = computed(() => competition.value?.registrationEndDate);
        function openForm(c) {
            registrationEndDateOverride.value = c.registrationEndDate;
            competition.value = c;
            dialog.value = true;
        }
        async function submit() {
            try {
                mutationLoading.value = true;
                await apolloClient.mutate({
                    mutation: gql `
        mutation competitionUpdateRegistrationEndDateOverride(
          $competitionId: ID!
          $registrationEndDateOverride: Date!
        ) {
          competitionUpdateRegistrationEndDateOverride(
            input: {
              competitionId: $competitionId
              registrationEndDateOverride: $registrationEndDateOverride
            }
          ) {
            competition {
              id
              registrationEndDate
            }
          }
        }
      `,
                    variables: {
                        competitionId: competition.value.id,
                        registrationEndDateOverride: registrationEndDateOverride.value
                    }
                });
                dialog.value = false;
            }
            catch (error) {
                snackbarServerError(error, { level: "error" });
            }
            finally {
                mutationLoading.value = false;
            }
        }
        __expose({ openForm });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(AppDialogContent, {
                modelValue: dialog.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((dialog).value = $event)),
                loading: mutationLoading.value,
                disabled: mutationLoading.value,
                "disabled-submit": !registrationEndDateOverride.value,
                "data-test": "registrationEndDateOverrideForm",
                onSubmitForm: submit
            }, {
                header: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("events:EventPage.competitionUpdateRegistrationEndDateOverrideForm.heading", "Change last date for entries for FEI event")), 1)
                ]),
                default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("events:EventPage.competitionUpdateRegistrationEndDateOverrideForm.hint", "You are going to change the last date for online entries for FEI event. Please note, the event will stay open for entries until the selected date. If date is in the past, entries will be closed. Below you will find the definite entries date as defined in FEI system as well as the current last date for entries for this event.")), 1),
                    _createElementVNode("div", _hoisted_1, [
                        _createTextVNode(_toDisplayString(_ctx.$t("events:EventPage.competitionUpdateRegistrationEndDateOverrideForm.nominatedEntriesDate.label", "Nominated entries date in FEI system:")) + " ", 1),
                        _createElementVNode("b", null, _toDisplayString(_ctx.$dayjs.date(nominatedEntriesDate.value)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_2, [
                        _createTextVNode(_toDisplayString(_ctx.$t("events:EventPage.competitionUpdateRegistrationEndDateOverrideForm.definiteEntriesDate.label", "Definite entries date in FEI system:")) + " ", 1),
                        _createElementVNode("b", null, _toDisplayString(_ctx.$dayjs.date(definiteEntriesDate.value)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _createTextVNode(_toDisplayString(_ctx.$t("events:EventPage.registrationEndDate.label", "Current last date for entries:")) + " ", 1),
                        _createElementVNode("b", null, _toDisplayString(_ctx.$dayjs.date(registrationEndDate.value)), 1)
                    ]),
                    _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.$t("events:EventPage.competitionUpdateRegistrationEndDateOverrideForm.registrationEndDateOverride.subheading", "Select new last date for entries")), 1)
                    ]),
                    _createVNode(AppDatePicker, {
                        modelValue: registrationEndDateOverride.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((registrationEndDateOverride).value = $event)),
                        label: _ctx.$t('events:EventPage.competitionUpdateRegistrationEndDateOverrideForm.registrationEndDateOverride.label', 'New last date for entries'),
                        "data-test": "registrationEndDateOverride",
                        max: event.value.startDate
                    }, null, 8, ["modelValue", "label", "max"])
                ]),
                _: 1,
                __: [2]
            }, 8, ["modelValue", "loading", "disabled", "disabled-submit"]));
        };
    }
});
